export const getBookName = () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'sonja-thomas'
  } else {
    const [bookName] = window.location.hostname.split('.')
    return bookName;
  }
}